import { observer } from 'mobx-react';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { Button, Input, InputCalendar, InputDropdown, InputType } from '../../../../core/components/Index';
import { Tag } from 'primereact/tag';

const TempEmploymentForm = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  return (
    <>
    {!(vm.isAddingEstimate || vm.isEditingEstimate) && 
          <>
            <h1 className="text-32px tracking-[-1%] text-[#363636] font-semibold mb-[4px]">Details Needed for Estimate — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <p className="tracking--1percent">
            </p>
            <div className="w-full text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[40px]">
              <p className ="pt-3 pb-3 mb-[12px]">Provide the information below to calculate a preliminary estimate for purchasing service credit related to temporary, seasonal, or on-call employment before you became a SCERS member.</p>
              <ul className="mb-[24px] space-y-[2px] ml-[10px] tracking-[1.5%]">
                <li className="flex items-start gap-2">
                  <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="">
                    You may enter up to five separate periods of temporary, seasonal, or on-call employment.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="">
                    Periods cannot overlap.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                  <span className="">
                    For each period, the system will calculate hours automatically, assuming a 40-hour work week. Adjust this value to reflect your actual work hours.
                  </span>
                </li>
              </ul>
            </div>
            </>
        }
        {(vm.isEditingEstimate) && 

          <>
            <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <p className="tracking--1percent">
            </p>
            <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
              <p className ="pt-3 pb-3">Edit the details for this employment period. Remember: periods can’t overlap, and you may enter up to five total employment periods.</p>
            </div>
          </>

        }
        {(vm.isAddingEstimate) && 

          <>
            <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <p className="tracking--1percent">
            </p>
            <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
              <p className ="pt-3 pb-3">Add the details for your next employment period. Remember: periods can’t overlap, and you may enter up to five total employment periods.</p>
            </div>
          </>

        }
        <div className="max-w-6xl mx-auto">
          <h2 className="text-[22px] font-semibold text-[#363636] leading-[100%] tracking-[0px] mt-[40px] mb-[40px]">
            Your Information
          </h2>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px] w-full max-w-[800px]">
            <p className="pt-3 font-bold mb-[-2px]">
              Employer
            </p>
            <p className='mb-[-2px]'>
              Select the SCERS-participating employer where you performed your temporary, seasonal, or on-call work (before you joined SCERS)
            </p>
          </div>
          <div className='mb-[16px]'>
          <InputDropdown
            id="mbrEmployer"
            value={vm.currentEstimationDetail.mbrEmployer}
            options={vm.spcLovModel?.employerListItems}
            optionValue="value"
            optionLabel="code"
            placeholder="Select Employer"
            onChange={async (e) => {
              vm.onInputChange(e, 'mbrEmployer', vm.currentEstimationDetail);
              await vm.onEmployerChangeAsync();
            }}
            style={{ width: '343px' }}
            required={true}
          />
          </div>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
          <p className="pt-3 font-bold mb-[-8px]">
            Membership Entry Date
          </p>
          <div className="grid grid-cols-1 gap-[20px]">
            <div className=" ">
            <InputCalendar
                  id="mbrEntryDate"
                  className='w-[50vw] md:w-[180px] h-[38px]'
                  value={vm.currentEstimationDetail?.mbrEntryDate!}
                  label=" "
                  showHint={true}
                  onChange={(e) => {
                    vm.onInputChange(e, 'mbrEntryDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync()}
                  required={false}
                />
          </div>
          </div>
          </div>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[16px]">
          <p className="pt-3 font-bold mb-[-2px]">
            Membership Tier at Entry
          </p>
          <p className='mb-[-2px]'>
            Select the membership tier that applied when you joined SCERS.
          </p>
          </div>
          <div className='mb-[16px]'>
            <InputDropdown
            id="mbrTierId"
            value={vm.currentEstimationDetail.mbrTierId}
            options={vm.spcLovModel?.membershipTierListItems}
            optionValue="key"
            optionLabel="value"
            placeholder="Select Membership Tier"
            onChange={(e) => {
              vm.onInputChange(e, 'mbrTierId', vm.currentEstimationDetail);
            }}
            style={{ width: '285px' }}
            required={true}
          />
          </div>

          <div className="text-[15px] leading-[175%] tracking-[-1.5%] mb-[20px]">
            <p className="pt-3 font-bold">
              Employment Period
            </p>
            <p>
              Please enter the start and end dates of your temporary, seasonal, or on-call employment.
            </p>
          </div>
          <div className="md:max-w-[400px] grid grid-cols-1 md:grid-cols-2 gap-[20px] mb-[24px]">
            <div className=" ">
              <InputCalendar
                  className='w-[50vw] md:w-[180px] h-[38px]'
                  id="startDate"
                  value={vm.currentEstimationDetail?.startDate!}
                  label="From"
                  showHint={true}
                  onChange={(e) => {
                    vm.onInputChange(e, 'startDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync()}
                  required={false}
                />
            </div>
            <div className=" ">
              <InputCalendar
                  className='w-[50vw] md:w-[180px] h-[38px]'
                  id="endDate"
                  value={vm.currentEstimationDetail?.endDate!}
                  label="To"
                  showHint={true}
                  onChange={(e) => {
                    vm.onInputChange(e, 'endDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync()}
                  required={false}
                />
            </div>
          </div>
          <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px] mt-[20px] w-full max-w-[800px]">
            <p className="pt-3 font-bold mb-[-4px]">
              Estimated Hours of Service
            </p>
            <p className='leading-[175%] tracking-[-1.5%]'>
              We calculate hours from your date range assuming a 40-hour work week. Adjust this value to reflect your actual work hours.
            </p>
          </div>
          <div className='flex flex-wrap justify-stretch items-center gap-[20px] mb-[32px]'>
            <div>
              <Input
                id="estSvcHours"
                value={vm.currentEstimationDetail.estSvcHours}
                inputType={InputType.Number}  
                onChange={(e:any) => {
                    vm.currentEstimationDetail.estSvcHours = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                }}
                required={false}
                style={{ width: '180px' }}
              />
            </div>
            {vm.currentEstimationDetail?.startDate && vm.currentEstimationDetail?.endDate && vm.currentEstimationDetail?.estSvcHours !== undefined && (
              <div className="mt-[6px] max-h-[60px] flex justify-stretch cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 rounded-md">
                <div className="border-2 border-orange-500 rounded-l-md px-1 flex items-center ">
                  <svg className="w-3 h-3"> 
                    <path
                      d="M5.4996 0.5C5.8047 0.5 6.08617 0.661144 6.24087 0.925421L10.8818 8.83224C11.0387 9.09866 11.0387 9.4274 10.8861 9.69382C10.7336 9.96025 10.4478 10.1257 10.1406 10.1257H0.858643C0.551395 10.1257 0.265632 9.96025 0.113082 9.69382C-0.0394677 9.4274 -0.0373191 9.09651 0.117379 8.83224L4.75834 0.925421C4.91304 0.661144 5.1945 0.5 5.4996 0.5ZM5.4996 3.2502C5.21384 3.2502 4.98394 3.4801 4.98394 3.76586V6.17228C4.98394 6.45804 5.21384 6.68794 5.4996 6.68794C5.78536 6.68794 6.01526 6.45804 6.01526 6.17228V3.76586C6.01526 3.4801 5.78536 3.2502 5.4996 3.2502ZM6.18715 8.06304C6.18715 7.88069 6.11471 7.70581 5.98577 7.57687C5.85683 7.44793 5.68195 7.37549 5.4996 7.37549C5.31725 7.37549 5.14237 7.44793 5.01343 7.57687C4.88449 7.70581 4.81205 7.88069 4.81205 8.06304C4.81205 8.24539 4.88449 8.42027 5.01343 8.54921C5.14237 8.67815 5.31725 8.75059 5.4996 8.75059C5.68195 8.75059 5.85683 8.67815 5.98577 8.54921C6.11471 8.42027 6.18715 8.24539 6.18715 8.06304Z"
                      fill="#CF7119"
                    />
                  </svg>
                </div>
                <div className='!font-extrabold'>
                  <Tag
                    severity="warning"
                    value="Hours calculated automatically — adjust as needed. Click to learn more."
                    className="!rounded-l-none !font-bold font-[700] !h-full mb-[2px]" style={{textTransform: 'none'}}
                    onClick={()=>Appl.MessageBox.show('The calculator automatically determines hours based on your leave dates and a 40-hour work week. This may not match your actual unpaid hours if you received partial pay, State Disability Insurance (SDI), or had intermittent absences. You can adjust the hours field to better reflect your actual situation.','About Estimated Hours of Leave','','Close',true)}
                  />
                </div>
              </div>
            )}
              </div>
              {/*Error Message if Value Is Less Than or Equal to Zero*/}
              {vm.currentEstimationDetail &&
                vm.currentEstimationDetail.estSvcHours !== undefined &&
                vm.currentEstimationDetail.estSvcHours <= 0 && (
                    <div className="text-red-600 text-[15px] font-semibold leading-[125%] mt-[-24px] mb-[-25px] w-[200px]">
                      Estimated hours must be at<br /> <center> least 1</center>
                    </div>
                )}
              <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px] mt-[20px]">
                  <p className="pt-3 font-bold mb-[-2px]">
                    Estimated Compensation
                  </p>
                   <p className='text-[15px] leading-[175%] tracking-[-1.5%]'>
                    Enter your pay rate during the period of employment and select the corresponding pay frequency.
                  </p>
                   <p className='text-[15px] leading-[175%] tracking-[-1.5%]'>
                    If your pay rate changed during this period, we recommend using the higher pay rate to produce a more conservative estimate.
                  </p>
                </div>
              <div className="flex flex-wrap items-center gap-[20px] mb-[32px]">
                <div>
                <Input
                    id="estmComp"
                    value={vm.currentEstimationDetail.estmComp}
                    inputType={InputType.Number}
                    onChange={(e:any) => {
                      vm.currentEstimationDetail.estmComp = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                    }}
                    prefix="$"
                    prefixPosition="left"
                    minFractionDigits={2}
                    formatNumbers={true}
                    numberAlignment="right"
                    placeholder="e.g. 12,000.00"
                    className="!w-[50vw] md:!w-[177px]"
                  />
              </div>
                <div>
                  <InputDropdown
                    id="comFreqId"
                    value={vm.currentEstimationDetail.comFreqId}
                    options={vm.spcLovModel?.compensationFrequencyListItems}
                    optionValue="key"
                    optionLabel="value"
                    placeholder="Select Frequency"
                    onChange={(e) => {
                      vm.onInputChange(e, 'comFreqId', vm.currentEstimationDetail);
                    }}
                    required={true}
                    className='!w-[50vw] md:!w-[285px] !h-[38px] mt-[4px]'
                  />
                </div>
              </div>
          </div>
          <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap mt-[55px]">
            <Button
              title="Save & Continue"
              rounded
              className='border border-[#34571933] !w-[161px]'
              onClick={async () => {
                await vm.onEnterDetailsStepChangeAsync();
              }}
              disabled={
                        vm.currentEstimationDetail?.mbrEmployer === ""
                        || vm.currentEstimationDetail?.mbrTierId === undefined
                        || vm.currentEstimationDetail?.mbrEntryDate === undefined
                        || vm.currentEstimationDetail?.endDate === null
                        || vm.currentEstimationDetail?.startDate === null
                        || vm.currentEstimationDetail?.estSvcHours === undefined
                        || vm.currentEstimationDetail?.estmComp === undefined
                        || vm.currentEstimationDetail?.comFreqId === undefined
                        || vm.currentEstimationDetail.estSvcHours === undefined
                        || vm.currentEstimationDetail.estSvcHours <= 0
                      }
            />
          {(vm.isAddingEstimate || vm.isEditingEstimate) && <Button title="Cancel" severity='warning' outlined rounded onClick={async () => await vm.cancelAddEstimateAsync()} />}
        </div>
    </>
  );
});

export default TempEmploymentForm;
